export const NAV_ACTIONS = {
  PREV: 'prev',
  NEXT: 'next',
}
